export interface Stat {
  label: string;
  value: number | string;
  color?: string; // tailwind text color class
}

export function StatTiles({ stats }: { stats: Stat[] }) {
  return (
    <div className="stat-strip">
      {stats.map((s) => (
        <div key={s.label} className="od-stat stat-cell">
          <span className={`stat-value ${s.color || ''}`}>{s.value}</span>
          <span className="stat-label">{s.label}</span>
        </div>
      ))}
    </div>
  );
}
